// @ts-nocheck

import { Button } from 'applaus-ui-kit'
import styled, { css } from 'styled-components'

export const Container = styled.div`
  ${({ theme }) => css`
    @media (max-width: 767px) {
      padding: ${theme.spacing.stack.xxs} 0;
    }
  `}
`

export const Wrapper = styled.div`
  ${({ theme }) => css`
    @media (max-width: 767px) {
      margin-top: ${theme.spacing.stack.xxs};
    }
  `}
`

export const Form = styled.form`
  ${({ theme }) => css`
    margin-top: ${theme.spacing.stack.xxxs};
  `}
`

export const HelperText = styled.p`
  ${({ theme }) => css`
    color: #39383a;
    font-size: ${theme.font.size.xs};
    line-height: 20px;
    margin-bottom: ${theme.spacing.stack.xxs};
  `}
`

export const ButtonBox = styled.div`
  ${({ theme }) => css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: ${theme.spacing.stack.xs};
    margin-bottom: ${theme.spacing.stack.xxs};

    @media (max-width: 767px) {
      justify-content: end;
    }
  `}
`

export const ButtonStyled = styled(Button)`
  background: #2ecc71;
`
